import React from 'react';
import { useSelector } from 'react-redux';
import uuid from '../Utils/UUID';
import Logo from './Logo';

const Footer = () => {
    const { sectionList, socialMediaLinks, logoUrl } = useSelector(
        (state) => state.footer
    );

    const mapLinkItems = ({ href, text }) => (
        <p key={uuid()}>
            <a className="footer__link" href={href}>
                {text}
            </a>
        </p>
    );

    const getSectionText = ({ value }) => (
        <div className='footer__section__text'
            dangerouslySetInnerHTML={{
                __html: value,
            }}
        ></div>
    );

    const mapSectionList = (i, k) =>
        k < 3 ? renderColumn(i, k) : renderFullWidth(i);

    const renderColumn = (
        { sectionTitle, sectionSubTitle, sectionLinkList, sectionText },
        index
    ) => (
        <section
            key={uuid()}
            className="columns small-10 small-offset-1 medium-offset-0 medium-3 footer__section"
        >
            <h4 className="footer__title">{sectionTitle}</h4>
            <h5 className="footer__subtitle">{sectionSubTitle}</h5>
            {getSectionText(sectionText)}
            <div>{sectionLinkList?.map(mapLinkItems)}</div>
            {index === 1 && (
                <div className="social-media-links">
                    {socialMediaLinks?.map(mapSocialMediaLinks)}
                </div>
            )}
        </section>
    );

    const renderFullWidth = ({ sectionTitle, sectionLinkList }) => (
        <section key={uuid()} className="columns small-10 small-offset-1 medium-offset-0 medium-12 footer__section">
            <div className="footer__horizontal-list">
                <Logo src={logoUrl} />
                <h4 className="footer__horizontal-list__title">{sectionTitle}</h4>
                {sectionLinkList?.map(({ href, text }) => (
                    <a className="footer__horizontal-list__link" href={href} key={uuid()}>
                        {text}
                    </a>
                ))}
            </div>
        </section>
    );

    const mapSocialMediaLinks = ({ url, imageUrl }) => {
        return (
            <a key={uuid()} href={url} target="_blank">
                <img src={imageUrl} />
            </a>
        );
    };

    return (
        <footer className="footer-hs">
            <div className="row">
                {sectionList?.map(mapSectionList)}
            </div>
        </footer>
    );
};

export default Footer;
